import React from 'react';
import { PRAIRI_SURFACES } from '../../constants/prairiSurfaces';

interface DashboardSectionTabProps {
  label: string;
  count?: number;
  variant?: 'default' | 'interested';
  iconSrc?: string;
  iconAlt?: string;
  active?: boolean;
  onClick?: () => void;
}

const OFF_WHITE = '#c8c8c8';
const rubikMedium = { fontFamily: 'Rubik, sans-serif', fontWeight: 500 } as const;

const DashboardSectionTab: React.FC<DashboardSectionTabProps> = ({
  label,
  count,
  variant = 'default',
  iconSrc,
  iconAlt = '',
  active,
  onClick,
}) => {
  const isInterested = variant === 'interested';
  const borderColor = isInterested ? 'border-[#92d050]' : 'border-[#2B9FEF]';
  const badgeBorder = isInterested ? 'border-[#92d050]' : 'border-[#2B9FEF]';

  const baseClasses = `relative inline-flex items-center justify-center gap-2.5 rounded-lg px-6 py-2 min-w-[140px] border-[0.5pt] font-medium [font-family:Rubik,sans-serif] transition-opacity whitespace-nowrap ${borderColor}`;
  const activeClasses = active === false ? 'opacity-40' : 'opacity-100';

  const labelEl = (
    <span
      className="text-sm whitespace-nowrap font-medium [font-family:Rubik,sans-serif]"
      style={{ ...rubikMedium, color: OFF_WHITE }}
    >
      {label}
    </span>
  );
  const countEl =
    typeof count === 'number' ? (
      <span
        className={`absolute -right-2.5 -top-2.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full border px-1.5 text-xs font-medium [font-family:Rubik,sans-serif] ${badgeBorder}`}
        style={{
          ...rubikMedium,
          color: OFF_WHITE,
          backgroundColor: PRAIRI_SURFACES.page,
        }}
      >
        {count}
      </span>
    ) : null;

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${baseClasses} ${activeClasses}`}
        style={rubikMedium}
      >
        {iconSrc ? (
          <img src={iconSrc} alt={iconAlt} className="h-4 w-4 shrink-0 object-contain opacity-90" />
        ) : null}
        {labelEl}
        {countEl}
      </button>
    );
  }

  return (
    <div className={`${baseClasses} ${activeClasses}`} style={rubikMedium}>
      {iconSrc ? (
        <img src={iconSrc} alt={iconAlt} className="h-4 w-4 shrink-0 object-contain opacity-90" />
      ) : null}
      {labelEl}
      {countEl}
    </div>
  );
};

export default DashboardSectionTab;
